// Import CSS for flag icons
//import 'flag-icons/css/flag-icons.min.css'

import './axios'
import './toast'

import type { App } from 'vue'

/**Load filters*/
import setupFilters from '@src/helper/filters'
/**Load Mixin */
import setupMixin from '@src/helper/mixin'

import setupISOString from './setupISOString'

import setupSw from './registerSw'

export default function (app: App) {
    if (!import.meta.env.PROD) {
        app.config.performance = true
    }
    setupSw()

    setupFilters(app)
    setupMixin(app)
    setupISOString(app)
}
